import { z } from 'zod';

export const departmentSchema = z.object({
  name: z.string().min(1, 'Department name is required').max(100, 'Department name is too long'),
});

export type DepartmentFormValues = z.infer<typeof departmentSchema>;
